import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "0870bca8-00e2-425e-8cd8-ce98b6b1c217",
    content: "It depends on the temperature",
    options: {},
  },
  {
    id: "998432c0-5b0b-45d3-98bc-ea68207f203b",
    content: "Up to 80 ms",
    options: {},
  },
  {
    id: "a247401b-6b6f-4f03-8bac-5dd12fbaace3",
    content: "15 ms",
    options: {},
  },
  {
    id: "b40ded31-816d-4306-9d47-9a9c6e4f9f23",
    content: "It depends on the speed of sound",
    options: {},
  },
  {
    id: "4c4a2707-f0c6-4498-8bab-7c7b451a1735",
    content: "5 ms",
    options: {},
  },
  {
    id: "27840904-e1a8-4c63-b780-34eec915b65a",
    content: "342 s",
    options: {},
  },
];

export const task: Task = {
  id: "f019734b-2d30-4de2-91f5-ba25d54f8f8a",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["998432c0-5b0b-45d3-98bc-ea68207f203b"],
};
